import { FC } from 'react'

import { FF, FormType, RadioGroup, Select, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const CashWithdrawals: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col2x>
          <SC.MainText>
            Rapid movement of funds, such as cash deposits followed by immediate cash withdrawals.
          </SC.MainText>
        </Col2x>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Review transaction activity for cash withdrawals. If withdrawals are found, check the date for immediate
            cash deposits prior to the withdrawal.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="cashWithdrawalsReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="cashWithdrawalsImmediateDeposits"
            children={(field) => (
              <FF
                field={field}
                label="Were there immediate deposits before cash withdraws? If so, what type?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'No Transactions of this Type',
                        value: 'no_transactions'
                      },
                      {
                        label: 'Change orders',
                        value: 'change_orders'
                      },
                      {
                        label: 'Product purchases',
                        value: 'product_purchases'
                      },
                      {
                        label: 'Other - See Comments',
                        value: 'other'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="cashWithdrawalsComments"
            children={(field) => (
              <FF field={field} label="Comments" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
